/**
 * @author Joshua Gui (jogui)
 * @fileOverview UserPhotoUrlHelper.ts: Generates the URL for a user's profile photo
 */

export enum UserPhotoSize {
  Small = 'S',  // 48 px
  Medium = 'M', // 72 px
  Large = 'L'   // 300 px
}

export interface IUserPhotoUrlParams {
  readonly webUrl?: string;
  readonly userLoginName: string;
  readonly size?: UserPhotoSize;
}

export function getUserPhotoUrl(photoUrlParams: IUserPhotoUrlParams): string {
  const webUrl: string = photoUrlParams.webUrl || '';
  const photoSizeParam: string = photoUrlParams.size || UserPhotoSize.Small;
  return `${webUrl}/_layouts/15/userphoto.aspx?accountname=${photoUrlParams.userLoginName}&size=${photoSizeParam}`;
}
